import React from 'react';
import { Empty } from 'antd';

/**
 * Consistent empty / no-data UI.
 *
 * @param {object}          props
 * @param {string}          [props.title='No data']
 * @param {string}          [props.description]
 * @param {React.ReactNode} [props.action]
 * @param {React.ReactNode} [props.icon]
 */
const EmptyState = ({
  title = 'No data',
  description,
  action,
  icon,
}) => (
  <Empty
    image={icon || Empty.PRESENTED_IMAGE_SIMPLE}
    description={
      <span style={{ color: 'var(--text-secondary)' }}>
        <strong style={{ display: 'block', color: 'var(--text-primary)', marginBottom: 4 }}>
          {title}
        </strong>
        {description}
      </span>
    }
  >
    {action}
  </Empty>
);

export default EmptyState;
